(() => {
  const filters = document.querySelector('.clinics-filters');
  const filterCountry = filters.querySelector('.clinics-filters-country select');
  const filterCity = filters.querySelector('.clinics-filters-city select');
  const items = document.querySelectorAll('.clinics-grid .card-clinic');
  const reset = filters.querySelector('.clinics-filters-reset');
  const countEl = filters.querySelector('.clinics-filters-count');
  const countTemplate = countEl ? countEl.dataset.showingText : '';

  const cityPlaceholder = filterCity.querySelector('option[data-option-placeholder]');
  const cityPlaceholderDisabled = cityPlaceholder ? cityPlaceholder.textContent : '';
  const cityPlaceholderActive = cityPlaceholder && cityPlaceholder.dataset.placeholderActive
    ? cityPlaceholder.dataset.placeholderActive
    : cityPlaceholderDisabled;

  const countryMap = {};

  items.forEach(item => {
    const json = JSON.parse(item.querySelector('.clinic-json').innerHTML);

    if (json && json.address && json.address.country) {
      const country = json.address.country;
      const city = json.address.city || '';

      if (!countryMap[country]) {
        countryMap[country] = [];
      }

      if (city && countryMap[country].indexOf(city) === -1) {
        countryMap[country].push(city);
      }
    }
  });

  const countries = Object.keys(countryMap).sort();

  countries.forEach(country => {
    const option = document.createElement('option');
    option.value = country;
    option.innerHTML = country;
    filterCountry.appendChild(option);

    countryMap[country].sort();
  });

  filterCountry.closest('custom-select').refresh();

  const populateCities = (country) => {
    while (filterCity.options.length > 1) {
      filterCity.remove(1);
    }

    const cityCustomSelect = filterCity.closest('custom-select');

    if (country && countryMap[country]) {
      countryMap[country].forEach(city => {
        const option = document.createElement('option');
        option.value = city;
        option.innerHTML = city;
        filterCity.appendChild(option);
      });

      filterCity.disabled = false;

      if (cityPlaceholder) {
        cityPlaceholder.textContent = cityPlaceholderActive;
      }
    } else {
      filterCity.disabled = true;

      if (cityPlaceholder) {
        cityPlaceholder.textContent = cityPlaceholderDisabled;
      }
    }

    filterCity.value = '';
    cityCustomSelect.refresh();
    cityCustomSelect.update();
  };

  const updateCount = () => {
    const visible = document.querySelectorAll('.clinics-grid .card-clinic:not(.hidden)');

    if (filterCountry.value && countEl) {
      countEl.textContent = countTemplate.replace('__COUNT__', visible.length);
      countEl.classList.remove('hidden');
    } else if (countEl) {
      countEl.textContent = '';
      countEl.classList.add('hidden');
    }
  };

  const filter = () => {
    const country = filterCountry.value;
    const city = filterCity.value;

    if (country) {
      reset.classList.remove('hidden');
    } else {
      reset.classList.add('hidden');
    }

    items.forEach(item => {
      const json = JSON.parse(item.querySelector('.clinic-json').innerHTML);
      let show = true;

      if (country && (!json || !json.address || json.address.country !== country)) {
        show = false;
      }

      if (show && city && (!json || !json.address || json.address.city !== city)) {
        show = false;
      }

      if (show) {
        item.classList.remove('hidden');
      } else {
        item.classList.add('hidden');
      }
    });

    updateCount();
  };

  filterCountry.addEventListener('change', () => {
    populateCities(filterCountry.value);
    filter();
  });

  filterCity.addEventListener('change', () => {
    filter();
  });

  reset.addEventListener('click', e => {
    e.preventDefault();

    filterCountry.value = '';
    filterCountry.dispatchEvent(new Event('change'));
    filterCity.value = '';
    filterCity.disabled = true;
    filterCity.closest('custom-select').refresh();
    filter();
  });
})();
